$(document).ready(function(){
    $('input[name="contact[email]"]').attr('aria-label', 'Enter your email');
    $('iframe[src*="iwvsBJ-V39M"]').attr('title', 'Video: King Bed That Transforms Into Two Twin XL Beds');
$('iframe[src*="_gvrwowiuzs"]').attr('title', 'Video: Date night redefind');
$('iframe[src*="2u7y54W1gcE"]').attr('title', 'Video: Two Beds. One Bedtime Story.');
$('iframe[src*="0DePxe1Jzss"]').attr('title', 'Video: Space for life');

$('.zip-checker h4').replaceWith(function () {
  return '<p class="zip-heading">' + $(this).text() + '</p>';
});

$("div.module-inline-item.home-inline-feature.cases h4.feature-title").replaceWith(function () {
  return '<p class="feature-titles">' + $(this).text() + '</p>';
});

let Intervaltime_task;
let counter_task = 0; 


try {
    Intervaltime_task = setInterval(GenerateAriaLabelFortask, 500);
}
catch (err) {
  
}


function GenerateAriaLabelFortask() {
   
   counter_task++;


   
    if ( $('textarea[name="g-recaptcha-response"]').length) {

$('textarea[name="g-recaptcha-response"]').attr('aria-label', 'reCAPTCHA verification');

        clearInterval(Intervaltime_task);
       
    }
    
  
    if (counter_task >= 20) {
        clearInterval(Intervaltime_task);
       
    }
}
$("input#zipCodeInput").attr("aria-label","Enter zip code");
$("input.product-quantity-input").attr("aria-label","Enter product quantity");

$("button[class^='multicolumns-video-player']").attr("aria-label","video player");
$('input[name="contact[Name]"]').attr('aria-label', 'Enter your name');

$('input[name="contact[Phone number]"]').attr('aria-label', 'Enter your phone number');

$('textarea[name="contact[Comments]"]').attr('aria-label', 'Enter your message');
$('img[src="//castawaybed.com/cdn/shop/files/ChatGPT_Image_Jan_22_2026_08_40_26_PM.png?v=1771298341&width=1500"]').attr('alt', 'Spacious bedroom');
$('img[src="//castawaybed.com/cdn/shop/files/Asset_7_140x31.svg?v=1767804713"]').attr('alt', 'Castaway Bed logo');
setTimeout(() => {
  $('img[src="https://d3k81ch9hvuctc.cloudfront.net/company/SxhhYR/images/6b0ad36e-b68e-4269-8efb-b7033c6f45b6.png"]').attr('alt', 'Couple enjoying on separate beds');
}, 1000);
$('img[src="//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_17_2026_08_47_31_PM.png?v=1771379909&width=2000"]').attr('alt', 'Two separate beds with a cozy background');

$('img[src="//castawaybed.com/cdn/shop/files/Untitled_700_x_700_px_700_x_400_px.png?v=1771380201&width=2000"]').attr('alt', 'Two separate beds with a cozy background');
$('input[name="contact[Order number]"]').attr('aria-label', 'Enter order number');
$('img[src="//castawaybed.com/cdn/shop/files/55f1cfea-48f7-44a7-a7ed-e0b912688a3c_878x640.png?v=1770406721"]').attr('alt', 'Person installing a bed');
$('img[src="//castawaybed.com/cdn/shop/files/image_17_1_709x640.png?v=1769509695"]').attr('alt', 'Two beds with a cozy background');
$('img[src="//castawaybed.com/cdn/shop/files/0ea7f085-0122-460e-9b23-28f2a2c79636_660x378.png?v=1771387008"]').attr('alt', 'Modern bedroom with two separate beds and neutral decor'); $('img[src="//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_17_2026_10_36_56_PM_660x440.png?v=1771385830"]').attr('alt', 'Two separate beds in a cozy bedroom setting'); $('img[src="//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_17_2026_11_06_44_PM_660x440.png?v=1771387614"]').attr('alt', 'Bedroom with dual bed configuration and warm lighting');
$('img[src="//castawaybed.com/cdn/shop/files/3.png?v=1771382779&width=2000"]').attr('alt', 'Bedroom with city view');
let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;
 

   
    if ( $('#goog-gt-votingInputSrcLang').length) {
$('img[src="https://fonts.gstatic.com/s/i/productlogos/translate/v14/24px.svg"]').attr('alt','Google Translate logo');
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
 $("img.add-to-cart__success").attr("alt","add to cart success");     
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 20) {
        clearInterval(Intervaltime_google);
       
    }
}

$("img[src=\"//castawaybed.com/cdn/shop/files/464f0275-9d6f-4c2a-897b-7458e4594da2.png?v=1771280844\"]").attr("alt", "Couple in bed with baby, night setting");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_11_36_30_PM.png?v=1770698202\"]").attr("alt", "Phone, glasses, and outlet on wooden nightstand");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_open__the_pet_is_sleeping_on_middle__copy.jpg?v=1770669031\"]").attr("alt", "Couple and cat on large bed with wooden frame");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_02_57_27_PM.png?v=1770669060\"]").attr("alt", "Couple sleeping in bed with beige blankets and headboard.");
$("img[src=\"//fonts.gstatic.com/s/i/productlogos/translate/v14/24px.svg\"]").attr("alt", "Google logo with airplane icon");
$("img[src=\"//d3k81ch9hvuctc.cloudfront.net/company/SxhhYR/images/6b0ad36e-b68e-4269-8efb-b7033c6f45b6.png\"]").attr("alt", "Couple relaxing on two connected beds in a modern bedroom");
$('img[src="//castawaybed.com/cdn/shop/files/vgelman88-01_1_100x100.svg?v=1769512850"]').attr('alt','Customer review icon');

$('img[src="//castawaybed.com/cdn/shop/files/vgelman88-05_1_100x100.svg?v=1769512922"]').attr('alt','Modular sofa design icon');

$('img[src="//castawaybed.com/cdn/shop/files/castaway-icons-white_100x100.svg?v=1770072669"]').attr('alt','right hand icon');

$('img[src="//castawaybed.com/cdn/shop/files/castaway-icon-white-06_100x100.svg?v=1770072856"]').attr('alt','truck icon');
$("img[src=\"//castawaybed.com/cdn/shop/files/1c04e65c-0347-4b26-bd2f-b8b52f295422_1024x683.png?v=1770669031\"]").attr("alt", "Modern bedroom with wooden bed and nightstands");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_2inch_open_couple_faces_to_each_other_copy_1024x576.jpg?v=1770669031\"]").attr("alt", "Couple sitting on bed with blankets and pillows.");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_open_mom_holding_baby_new_bassinet_copy_1024x576.jpg?v=1770669031\"]").attr("alt", "Couple and baby in beds with shared crib space");
$("img[src=\"//castawaybed.com/cdn/shop/files/new_fully_closed_copy_1024x576.jpg?v=1770669031\"]").attr("alt", "Couple sleeping in bed with beige blankets and pillows.");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_open__the_pet_is_sleeping_on_middle__copy_1024x576.jpg?v=1770669031\"]").attr("alt", "Couple and cat on split bed with wooden frame.");
$("img[src=\"//castawaybed.com/cdn/shop/files/1c04e65c-0347-4b26-bd2f-b8b52f295422_100x67.png?v=1770669031\"]").attr("alt", "Modern bedroom with wooden bed frame and nightstands");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_2inch_open_couple_faces_to_each_other_copy_100x57.jpg?v=1770669031\"]").attr("alt", "Couple lying in bed with beige blankets and blue sheets.");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_open_mom_holding_baby_new_bassinet_copy_100x57.jpg?v=1770669031\"]").attr("alt", "Two people lying in beds with white sheets and blankets.");
$("img[src=\"//castawaybed.com/cdn/shop/files/new_fully_closed_copy_100x57.jpg?v=1770669031\"]").attr("alt", "Couple lying in bed with beige bedding and pillows");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_open__the_pet_is_sleeping_on_middle__copy_100x57.jpg?v=1770669031\"]").attr("alt", "Two people lying in bed with white sheets in a beige room.");
$("img[src=\"//castawaybed.com/cdn/shop/files/width_1344.png?v=1771291384\"]").attr("alt", "Modern hotel room with two beds and abstract art");
$("img[src=\"//castawaybed.com/cdn/shop/files/Untitled_1200_x_630_px_524x275.png?v=1771281803\"]").attr("alt", "Couple relaxing on two connected beds with a tray of snacks between them.");
$("img[src=\"//castawaybed.com/cdn/shop/files/Untitled_design_5_524x275.png?v=1771281813\"]").attr("alt", "Couple lying in beds with gap, using phones.");
$("img[src=\"//castawaybed.com/cdn/shop/files/Untitled_design_6_524x275.png?v=1771281813\"]").attr("alt", "Woman sitting on bed with two dogs.");
$("img[src=\"//castawaybed.com/cdn/shop/files/Untitled_design_7_524x275.png?v=1771281813\"]").attr("alt", "Couple relaxing on two beds in a modern hotel room.");
$("img[src=\"//castawaybed.com/cdn/shop/files/place-order-icon.svg?v=1771293883\"]").attr("alt", "Computer monitor and mouse icon");
$("img[src=\"//castawaybed.com/cdn/shop/files/calendar-icon.svg?v=1771293892\"]").attr("alt", "Calendar icon with blank date");
$("img[src=\"//castawaybed.com/cdn/shop/files/home-delivery-icon.svg?v=1771293895\"]").attr("alt", "House with smoke coming out");
$("img[src=\"//castawaybed.com/cdn/shop/files/customer-support-icon.svg?v=1771294306\"]").attr("alt", "Sad face wearing headphones");
$("img[src=\"//d3k81ch9hvuctc.cloudfront.net/company/SxhhYR/images/6b0ad36e-b68e-4269-8efb-b7033c6f45b6.png\"]").attr("alt", "Couple relaxing on two beds in a modern bedroom");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_03_28_58_PM_1024x683.png?v=1770669060\"]").attr("alt", "Modern bedroom with beige bed and nightstands");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_02_55_31_PM_1024x683.png?v=1770669060\"]").attr("alt", "Couple sitting on separate beds in a bedroom");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_03_01_01_PM_1024x683.png?v=1770669060\"]").attr("alt", "Couple and baby sleeping in split king bed");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_02_57_27_PM_1024x683.png?v=1770669060\"]").attr("alt", "Couple sleeping in bed with blankets and pillows.");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_2inch_open_diff_headboard_copy_1024x576.jpg?v=1770669060\"]").attr("alt", "Couple lying in bed with wooden headboard and nightstands");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_03_20_41_PM_1024x683.png?v=1770669060\"]").attr("alt", "Couple sitting on separate beds in a modern bedroom.");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_03_28_58_PM_100x67.png?v=1770669060\"]").attr("alt", "Modern bedroom with double bed and nightstands");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_02_55_31_PM_100x67.png?v=1770669060\"]").attr("alt", "Couple lying in bed with beige blankets and blue sheets.");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_03_01_01_PM_100x67.png?v=1770669060\"]").attr("alt", "Two women lying in bed with a crib between them.");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_02_57_27_PM_100x67.png?v=1770669060\"]").attr("alt", "Couple lying in bed under blankets with tufted headboard behind.");
$("img[src=\"//castawaybed.com/cdn/shop/files/bed_2inch_open_diff_headboard_copy_100x57.jpg?v=1770669060\"]").attr("alt", "Couple lying in bed together in a beige bedroom.");
$("img[src=\"//castawaybed.com/cdn/shop/files/ChatGPT_Image_Feb_9_2026_03_20_41_PM_100x67.png?v=1770669060\"]").attr("alt", "Two people lying in bed, covered with blankets.");

$("img[src=\"https://d3k81ch9hvuctc.cloudfront.net/company/SxhhYR/images/6b0ad36e-b68e-4269-8efb-b7033c6f45b6.png\"]").attr("alt", "Couple relaxing on beds in a modern bedroom");
$("img[src=\"https://d3k81ch9hvuctc.cloudfront.net/company/SxhhYR/images/6b0ad36e-b68e-4269-8efb-b7033c6f45b6.png\"]").attr("alt", "Couple relaxing on beds in a modern bedroom.");
});